(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('DownloadPurchaseInvoicePDFController',DownloadPurchaseInvoicePDFController);

    DownloadPurchaseInvoicePDFController.$inject = ['$uibModalInstance'];

    function DownloadPurchaseInvoicePDFController($uibModalInstance) {
        var vm = this;

        vm.showStuff = ['Show', 'Hide'];

        vm.formElement = {
            header: 1,
            showVoyageDetails: 'Show',
            showDescriptionOfGoods: 'Show',
            showPacking: 'Show',
            showIncoTerms: 'Show',
            showWeightTerm: 'Show',
            showPaymentTerms: 'Show',
            showPaymentInstruction: 'Show'
        };

        vm.currentHeader = "";

        applyHeader();

        vm.clear = clear;
        vm.submit = submit;
        vm.updateHeader = updateHeader;
        vm.updateShowVoyageDetails = updateShowVoyageDetails;
        vm.updateShowDescriptionOfGoods = updateShowDescriptionOfGoods;
        vm.updateShowPacking = updateShowPacking;
        vm.updateShowIncoTerms = updateShowIncoTerms;
        vm.updateShowWeightTerm = updateShowWeightTerm;
        vm.updateShowPaymentTerms = updateShowPaymentTerms;
        vm.updateShowPaymentInstruction = updateShowPaymentInstruction;
        vm.updateAll = updateAll;

        function updateHeader(option) {
            vm.formElement.header = option;
            applyHeader();
        }

        function applyHeader() {
            switch(vm.formElement.header) {
                case 1:
                    vm.currentHeader = "TOYOSHIMA INTERNATIONAL AMERICA, INC.<br/>19600 MAGELLAN DRIVE<br/>TORRANCE CA 90502 USA<br/>Tel: 310-879-4450<br/>Fax: 310-879-4451";
                    break;
                case 2:
                    vm.currentHeader = "TOYOSHIMA & CO., LTD.<br/>15-15, NISHIKI 2-CHOME,<br/>NAKAKU, NAGOYA, 460-8671 JAPAN<br/>Tel: 81-52-204-7502<br/>Fax: 81-52-204-7423";
                    break;
            }
        }

        function updateShowVoyageDetails(option) {
            vm.formElement.showVoyageDetails = option;
        }

        function updateShowDescriptionOfGoods(option) {
            vm.formElement.showDescriptionOfGoods = option;
        }

        function updateShowPacking(option) {
            vm.formElement.showPacking = option;
        }

        function updateShowIncoTerms(option) {
            vm.formElement.showIncoTerms = option;
        }

        function updateShowWeightTerm(option) {
            vm.formElement.showWeightTerm = option;
        }

        function updateShowPaymentTerms(option) {
            vm.formElement.showPaymentTerms = option;
        }

        function updateShowPaymentInstruction(option) {
            vm.formElement.showPaymentInstruction = option;
        }

        function updateAll(option) {
            vm.formElement.showVoyageDetails = option;
            vm.formElement.showDescriptionOfGoods = option;
            vm.formElement.showPacking = option;
            vm.formElement.showIncoTerms = option;
            vm.formElement.showWeightTerm = option;
            vm.formElement.showPaymentTerms = option;
            vm.formElement.showPaymentInstruction = option;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function submit() {
            $uibModalInstance.close(vm.formElement);
        }

    }
})();
